<div *ngIf="isFliptoStaff || (links$ | async)?.length" class="ft-custom-links-section mxn-pattern-pinstripe">
    <div class="ft-row">
        <div class="ft-col-50 ft-section-info ft-tooltip opens-center">
            <p>
                Shortened links are also available for specific outreach where a cleaner URL is more convenient, such as in posters, flyers, and other printed collateral. These links will always route to the invitation page for the current, active campaign.
            </p>
            <div *ngIf="isFliptoStaff" class="v-start mt-3">
                <button
                    class="ft-link ft-link-underline"
                    (click)="newShortUrlModal.show()"
                >
                    Create a link
                </button>&nbsp;
                <span class="pl-1 v-center">
                    <span class="icon v-center">
                        <img src="/dist/v2-hybrid/v1-assets/img/icon-lock.svg" />
                    </span>
                    <span class="bolder-text icon muted-text small-text">
                        For Flip.to only
                    </span>
                </span>
            </div>
            <ft-tooltip #tooltip1>
                <ng-template>
                    Broadcast links are dynamic&mdash;they'll always route to the current, active campaign for your target audience so you'll never send people to outdated experiences.
                </ng-template>
            </ft-tooltip>
        </div>
        <div class="ft-col-50 ft-custom-links-list scroll-block">

            <div class="ft-custom-link ft-tooltip opens-right" *ngFor="let link of links$ | async">
                <div class="ft-row">
                    <div class="ft-col-50">
                        <div class="ft-custom-link-name">{{ link.displayName }}</div>
                    </div>
                    <div class="ft-col-50">
                        <div class="ft-custom-link-URL url-text">
                            https://go.flip.to/{{ link.shortCode }} <i class="ft-icn-info ft-tooltip-toggle" (click)="tooltip2.show()"></i>
                        </div>
                    </div>
                </div>
                <ft-tooltip #tooltip2>
                    <ng-template>
                        This link sends visitors to: <span class="url-text">{{ link.destinationUrl }}</span>
                    </ng-template>
                </ft-tooltip>
            </div>

        </div>
    </div>
</div>

<ft-modal #newShortUrlModal id="photoContest.newShortUrl" [doneVisible]="false">
  <ng-template>
    <ft-short-url-wizard [params]="setupOptions" (done)="onShortUrlWizardComplete()" />
  </ng-template>
</ft-modal>
